import {h} from 'ui/Framework';

export default h('svg', {
  width: '179',
  height: '36',
  viewBox: '0 0 179 36',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fillRule: 'nonzero',
    fill: '#E4F1FD'
  }, [
    h('path', {
      d: 'M11.554 28.55L16.336 1H23v35h-4.192V7.05L13.65 36H9.243L4.084 7.05V36H0V1h6.77zM38.892 1v3.7h-7.568v11.6h7.297v3.65h-7.297V32.3H39V36H27V1zM46.793 36V4.7H41V1h16v3.7h-5.793V36h-4.414zM73 36h-4.223l-.909-5.833h-6.896L60.116 36H56l5.774-35h5.452L73 36zm-11.494-9.423h5.827L64.446 7.282l-2.94 19.295zM81.528 1v31.3H89V36H77V1zM106 24.27v5.157c0 4.399-2.304 6.573-6.964 6.573h-1.179C93.25 36 91 33.826 91 29.528v-7.433h4.179v7.585c0 1.82.91 2.68 2.839 2.68h.857c1.929 0 2.84-.86 2.84-2.68v-5.31c0-1.769-.643-2.527-1.876-3.387l-5.25-3.59C91.804 15.523 91 13.703 91 10.82V6.573C91 2.174 93.304 0 97.964 0h1.072c4.607 0 6.857 2.174 6.857 6.472v6.37h-4.179V6.32c0-1.82-.91-2.68-2.839-2.68h-.75c-1.929 0-2.84.86-2.84 2.68v4.45c0 1.77.697 2.528 1.93 3.387l5.196 3.54c2.732 1.87 3.589 3.539 3.589 6.573zM121.554 28.55L126.336 1H133v35h-4.192V7.05L123.65 36h-4.406l-5.159-28.95V36H110V1h6.77zM142 36h-4V1h4zM150.793 36V4.7H145V1h16v3.7h-5.793V36h-4.414zM174.586 16.25V1H179v35h-4.414V20h-7.172v16H163V1h4.414v15.25h7.172z'
    })
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/metalsmith.es6.js